import { preload } from './modules/preload'
import { nav } from './modules/nav'
import { slider } from './modules/slider'
import { facts } from './modules/facts'
import { toggleItem } from './modules/toggleItem'
import { counter } from './modules/counter'
import { lightbox } from './modules/lightbox'
import { openFilter } from './modules/openFilter'
import { openMap } from './modules/openMap'
import { onScroll } from './modules/onScroll'
import { dialog } from './modules/dialog'
import { bannerForms } from './modules/bannerForms'
import { accessibility } from './modules/accessibility'
import { iframeHeightCalc } from './modules/iframeHeightCalc'
import { devicecheck } from './modules/devicecheck'
import { locationTabs } from './modules/locationTabs'
import { feedbackTruncate } from './modules/feedbackTruncate'
import { propertiesNav } from './modules/propertiesNav'
import { introPin } from './modules/gsap'
import { principleWheel } from './modules/principleWheel'

window.onload = function () {
	slider()
	onScroll()
	preload()
	nav()
	openFilter()
	openMap()
	lightbox()
	counter()
	dialog()
	toggleItem()
	facts()
	bannerForms()
	accessibility()
	iframeHeightCalc()
	devicecheck()
	locationTabs()
	feedbackTruncate()
	propertiesNav()
	principleWheel()

	introPin()
	gsap.registerPlugin(ScrollTrigger)

	// Function to get current .inner width excluding padding
	const getInnerWidth = () => {
		const innerElement = document.querySelector('.inner')
		if (!innerElement) return '95%'

		const styles = getComputedStyle(innerElement)
		const paddingLeft = parseFloat(styles.paddingLeft) || 0
		const paddingRight = parseFloat(styles.paddingRight) || 0
		const contentWidth = innerElement.clientWidth - paddingLeft - paddingRight

		return `${contentWidth}px`
	}

	// Function to get height that maintains aspect ratio
	const getAspectRatioHeight = () => {
		const imgElement = document.querySelector('.img-wrapper img')
		const innerElement = document.querySelector('.inner')

		if (!imgElement || !innerElement) return '500px'

		// Wait for image to load if not already loaded
		if (!imgElement.complete || imgElement.naturalWidth === 0) {
			return '500px' // Fallback while image loads
		}

		// Get target width (same as getInnerWidth but as number)
		const styles = getComputedStyle(innerElement)
		const paddingLeft = parseFloat(styles.paddingLeft) || 0
		const paddingRight = parseFloat(styles.paddingRight) || 0
		const targetWidth = innerElement.clientWidth - paddingLeft - paddingRight

		// Calculate height based on aspect ratio
		const aspectRatio = imgElement.naturalWidth / imgElement.naturalHeight
		const targetHeight = targetWidth / aspectRatio

		return `${targetHeight}px`
	}

	// Create a timeline linked to the scroll
	// Dynamically set scroll section height based on final image size
	const scrollSection = document.querySelector('.scroll-section')
	const finalImageHeight = getAspectRatioHeight()
	if (scrollSection) {
		const finalHeight = parseInt(finalImageHeight) + window.innerHeight * 1 // Add 50vh for animation space
		scrollSection.style.height = `${finalHeight}px`
	}

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: '.scroll-section',
			start: 'top top', // Start when section hits top
			end: 'bottom bottom', // End based on dynamic height
			scrub: 1, // Smoothly catch up to scroll
			pin: '.container', // Lock the container in place
		},
	})

	// Set initial state
	gsap.set('.img-wrapper', { height: '100vh' })

	tl.to('.img-wrapper', {
		width: getInnerWidth(), // Use the computed width of .inner element
		marginLeft: '0', // Remove the breakout margin
		marginRight: '0', // Remove the breakout margin
		left: '0', // Reset positioning
		height: getAspectRatioHeight(), // Maintain original aspect ratio
		ease: 'none',
	})

	// Handle window resize
	window.addEventListener('resize', () => {
		ScrollTrigger.refresh()
	})
}
